// extracted by mini-css-extract-plugin
module.exports = {"backButton":"components-GoBackToSearch-GoBackToSearch__backButton--mOJn1"};